export const paypalCallbackResponse = {
  authId:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.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.j2IwTPees6J1i4Br8wFRt5jUZj1cZsVt0oMBLzmpwKg',
  callbacks: [
    {
      type: 'TextOutputCallback',
      output: [
        {
          name: 'message',
          value: 'amaniciam02@yopmail.com',
        },
        {
          name: 'messageType',
          value: '0',
        },
      ],
      _id: 2,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_profile',
        },
        {
          name: 'prompt',
          value: 'Mon profil',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken2',
          value: '',
        },
        {
          name: 'IDToken2validateOnly',
          value: false,
        },
      ],
      _id: 3,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_professional',
        },
        {
          name: 'prompt',
          value: 'Professionnel',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_professional',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'Particulier',
        },
      ],
      input: [
        {
          name: 'IDToken3',
          value: 'Particulier',
        },
        {
          name: 'IDToken3validateOnly',
          value: false,
        },
      ],
      _id: 4,
    },
    {
      type: 'ValidatedCreatePasswordCallback',
      output: [
        {
          name: 'echoOn',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'password',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'prompt',
          value: 'Mot de passe',
        },
      ],
      input: [
        {
          name: 'IDToken4',
          value: '',
        },
        {
          name: 'IDToken4validateOnly',
          value: false,
        },
      ],
      _id: 5,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_contact',
        },
        {
          name: 'prompt',
          value: 'Mes coordonnées',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken5',
          value: '',
        },
        {
          name: 'IDToken5validateOnly',
          value: false,
        },
      ],
      _id: 6,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_gender',
        },
        {
          name: 'prompt',
          value: 'Genre',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_gender',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'Monsieur',
        },
      ],
      input: [
        {
          name: 'IDToken6',
          value: 'Monsieur',
        },
        {
          name: 'IDToken6validateOnly',
          value: false,
        },
      ],
      _id: 7,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'sn',
        },
        {
          name: 'prompt',
          value: 'Nom',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['REQUIRED', 'MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'sn',
            policies: [
              {
                policyRequirements: ['REQUIRED'],
                policyId: 'required',
              },
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\-]{1,255}",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'QAM',
        },
      ],
      input: [
        {
          name: 'IDToken7',
          value: 'QAM',
        },
        {
          name: 'IDToken7validateOnly',
          value: false,
        },
      ],
      _id: 8,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'givenName',
        },
        {
          name: 'prompt',
          value: 'Prénom',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['REQUIRED', 'MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'givenName',
            policies: [
              {
                policyRequirements: ['REQUIRED'],
                policyId: 'required',
              },
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\-]{1,255}",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'Amani',
        },
      ],
      input: [
        {
          name: 'IDToken8',
          value: 'Amani',
        },
        {
          name: 'IDToken8validateOnly',
          value: false,
        },
      ],
      _id: 9,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_birthday',
        },
        {
          name: 'prompt',
          value: 'Date de naissance',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_birthday',
            policies: [
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken9',
          value: '',
        },
        {
          name: 'IDToken9validateOnly',
          value: false,
        },
      ],
      _id: 10,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'telephoneNumber',
        },
        {
          name: 'prompt',
          value: 'Numéro de téléphone',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'telephoneNumber',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^0[1-79]\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}\\s?\\d{2}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken10',
          value: '',
        },
        {
          name: 'IDToken10validateOnly',
          value: false,
        },
      ],
      _id: 11,
    },
    {
      type: 'TextOutputCallback',
      output: [
        {
          name: 'message',
          value: 'bloctel_legal_mention',
        },
        {
          name: 'messageType',
          value: '0',
        },
      ],
      _id: 12,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_address',
        },
        {
          name: 'prompt',
          value: 'Mon adresse',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken12',
          value: '',
        },
        {
          name: 'IDToken12validateOnly',
          value: false,
        },
      ],
      _id: 13,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'postalCode',
        },
        {
          name: 'prompt',
          value: 'Code postal',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'postalCode',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^(?:0[1-9]|[1-8]\\d|9[0-8])\\d{3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '75020',
        },
      ],
      input: [
        {
          name: 'IDToken13',
          value: '75020',
        },
        {
          name: 'IDToken13validateOnly',
          value: false,
        },
      ],
      _id: 14,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'city',
        },
        {
          name: 'prompt',
          value: 'Ville',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'city',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s\\-]{1,30}$",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'PARIS',
        },
      ],
      input: [
        {
          name: 'IDToken14',
          value: 'PARIS',
        },
        {
          name: 'IDToken14validateOnly',
          value: false,
        },
      ],
      _id: 15,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'country',
        },
        {
          name: 'prompt',
          value: 'Pays',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['REQUIRED', 'NOT_NULL', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'country',
            policies: [
              {
                policyRequirements: ['REQUIRED'],
                policyId: 'required',
              },
              {
                policyRequirements: ['NOT_NULL'],
                policyId: 'not-null',
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'FRANCE',
        },
      ],
      input: [
        {
          name: 'IDToken15',
          value: 'FRANCE',
        },
        {
          name: 'IDToken15validateOnly',
          value: false,
        },
      ],
      _id: 16,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'postalAddress',
        },
        {
          name: 'prompt',
          value: 'Adresse',
        },
        {
          name: 'required',
          value: true,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'postalAddress',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s\\-]{1,30}$",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: 'RUE MAYET',
        },
      ],
      input: [
        {
          name: 'IDToken16',
          value: 'RUE MAYET',
        },
        {
          name: 'IDToken16validateOnly',
          value: false,
        },
      ],
      _id: 17,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_address2',
        },
        {
          name: 'prompt',
          value: "Complément d'adresse",
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_address2',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: "^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'\\s\\-]{1,30}$",
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken17',
          value: '',
        },
        {
          name: 'IDToken17validateOnly',
          value: false,
        },
      ],
      _id: 18,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_building',
        },
        {
          name: 'prompt',
          value: 'Bâtiment',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_building',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken18',
          value: '',
        },
        {
          name: 'IDToken18validateOnly',
          value: false,
        },
      ],
      _id: 19,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_stairs',
        },
        {
          name: 'prompt',
          value: 'Escalier',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_stairs',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken19',
          value: '',
        },
        {
          name: 'IDToken19validateOnly',
          value: false,
        },
      ],
      _id: 20,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_floor',
        },
        {
          name: 'prompt',
          value: 'Etage',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_floor',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken20',
          value: '',
        },
        {
          name: 'IDToken20validateOnly',
          value: false,
        },
      ],
      _id: 21,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_darty_door',
        },
        {
          name: 'prompt',
          value: 'Porte',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {
            policyRequirements: ['MATCH_REGEXP', 'VALID_TYPE'],
            fallbackPolicies: null,
            name: 'custom_darty_door',
            policies: [
              {
                policyRequirements: ['MATCH_REGEXP'],
                policyId: 'regexpMatches',
                params: {
                  regexp: '^[a-zA-Z0-9]{0,3}$',
                },
              },
              {
                policyRequirements: ['VALID_TYPE'],
                policyId: 'valid-type',
                params: {
                  types: ['string'],
                },
              },
            ],
            conditionalPolicies: null,
          },
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken21',
          value: '',
        },
        {
          name: 'IDToken21validateOnly',
          value: false,
        },
      ],
      _id: 22,
    },
    {
      type: 'StringAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'custom_section_consents',
        },
        {
          name: 'prompt',
          value: 'Mes préférences de contact',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: {},
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: '',
        },
      ],
      input: [
        {
          name: 'IDToken22',
          value: '',
        },
        {
          name: 'IDToken22validateOnly',
          value: false,
        },
      ],
      _id: 23,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_email_sms_out',
        },
        {
          name: 'prompt',
          value: 'Je souhaite recevoir par email et sms des offres personnalisées de la part de Darty.',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: true,
        },
      ],
      input: [
        {
          name: 'IDToken23',
          value: true,
        },
        {
          name: 'IDToken23validateOnly',
          value: false,
        },
      ],
      _id: 24,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_d_fd_part_exploit_out',
        },
        {
          name: 'prompt',
          value:
            'J’accepte que mon profil client soit utilisé pour profiter des offres personnalisées du Groupe Fnac Darty et de ses partenaires V4.\n',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: true,
        },
      ],
      input: [
        {
          name: 'IDToken24',
          value: true,
        },
        {
          name: 'IDToken24validateOnly',
          value: false,
        },
      ],
      _id: 25,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_part_email_sms_in',
        },
        {
          name: 'prompt',
          value: 'Je souhaite recevoir par email et sms des offres personnalisées du Groupe Fnac Darty et de ses partenaires.',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: false,
        },
      ],
      input: [
        {
          name: 'IDToken25',
          value: false,
        },
        {
          name: 'IDToken25validateOnly',
          value: false,
        },
      ],
      _id: 26,
    },
    {
      type: 'BooleanAttributeInputCallback',
      output: [
        {
          name: 'name',
          value: 'd_grp_d_part_phone_out',
        },
        {
          name: 'prompt',
          value: 'Je souhaite être contacté par Darty et ses partenaires pour des offres par téléphone.',
        },
        {
          name: 'required',
          value: false,
        },
        {
          name: 'policies',
          value: [],
        },
        {
          name: 'failedPolicies',
          value: [],
        },
        {
          name: 'validateOnly',
          value: false,
        },
        {
          name: 'value',
          value: true,
        },
      ],
      input: [
        {
          name: 'IDToken26',
          value: true,
        },
        {
          name: 'IDToken26validateOnly',
          value: false,
        },
      ],
      _id: 27,
    },
    {
      type: 'HiddenValueCallback',
      output: [
        {
          name: 'value',
          value: 'true',
        },
        {
          name: 'id',
          value: 'isSocial',
        },
      ],
      input: [
        {
          name: 'IDToken27',
          value: 'isSocial',
        },
      ],
      _id: 28,
    },
  ],
  stage: 'Registration Page',
};
